export enum AvailableStatusEnum {
  'Todos' = 'Todos',
  'Ativos' = 'Ativos',
  'Desativos' = 'Desativos',
}

export const availableStatusMap = (status: AvailableStatusEnum): boolean | null => {
  const available = {
    [AvailableStatusEnum.Todos]: null,
    [AvailableStatusEnum.Desativos]: false,
    [AvailableStatusEnum.Ativos]: true,
  };

  return available[status];
};
